export default __webpack_public_path__ + "static/media/learningVR.7bff30c2.JPG";